<template>
  <div>      
    <div id="busqueda-container" >      
        <input class="display-4 text-center" type="text" v-model="query_rut" placeholder="RUT"  @input="buscarRut" maxlength="9" minlength="9" size="9" @keypress="mayus">
    </div> 
</div> 
</template>

<script>

export default {
    name:'Busqueda',
    components:{
       
  
    },
    data(){
        return{
            query_rut:'',
            mirut:{},
        }
    },
    computed:{
        traerdatapersonas(){
            return this.$store.getters.enviardatapersonas;
        }
    },
    methods:{
        borrar(){
            this.query_rut=''
        },
        mayus() {            
            this.query_rut = this.query_rut.toUpperCase();
        },
        buscarRut(){
            if(this.query_rut.length===9){
                this.mirut = this.$store.getters.enviardatapersonas.filter(datos => {
                    return datos.rut.includes(this.query_rut.toUpperCase())
                });                
                if(!this.mirut.length){
                    console.log("Registrar nuevo visitante")                   
                    this.$router.push(`/personaadd/${this.query_rut}`);                    
                }else{                    
                    console.log("Mostrar datos y registrar entrada")
                    this.$router.push(`/personaentrada/${this.query_rut}`)
                    this.query_rut='';
                                      
                }
            }
        }
    }
}
</script>

<style>
#busqueda-container{
    margin-left: auto;
    margin-right: auto;
    width: 300px;
}
</style>